import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12a4 4 0 1 0 -4 -4","key":"svg-0"}],["path",{"d":"M8 16a4 4 0 1 0 4 -4","key":"svg-1"}]]

const IconNumber3 = createReactComponent('outline', 'number-3', 'Number3', __iconNode);

export default IconNumber3;